import type { ActivityHubViewProps } from "@/lib/activities/registry";
import { getPreferredName } from "@/lib/redacted-display";
import { ViewHotTakesView } from "./view-hot-takes-view";

export function HotTakesHubView({
  entityId,
  mentorship,
  initialIndex,
  mentorAvatarUrl,
  teenAvatarUrl,
  activeTab,
  onNavigateToList,
  readOnly,
}: ActivityHubViewProps) {
  return (
    <ViewHotTakesView
      entityId={entityId}
      mentorName={mentorship.mentor.name}
      teenName={getPreferredName(mentorship.mentee) || "Teen"}
      mentorId={mentorship.mentor.id}
      menteeId={mentorship.mentee.id}
      activeTab={activeTab}
      onNavigateToList={onNavigateToList}
      readOnly={readOnly}
      initialIndex={initialIndex}
      mentorAvatarUrl={mentorAvatarUrl}
      teenAvatarUrl={teenAvatarUrl}
    />
  );
}
